import React from 'react';
import PropTypes from 'prop-types';

import UiKitRadioButtonGroup from 'components/UiKit/RadioButtonGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faThList,
  faList,
  faSortAlphaUp,
  faSortAlphaDownAlt
} from '@fortawesome/free-solid-svg-icons';

const toolbarComponentsDefaultPropChangeView = () => {};
const toolbarComponentsDefaultPropChangeSort = () => {};
const ToolbarComponents = ({
  view,
  changeView = toolbarComponentsDefaultPropChangeView,
  sort,
  changeSort = toolbarComponentsDefaultPropChangeSort
}) => {
  return (
    <div data-testid="toolbar-container">
      <div className="flex">
        <UiKitRadioButtonGroup
          selected={view}
          onChange={event => {
            changeView(event);
          }}
        >
          <UiKitRadioButtonGroup.RadioButton
            name="comfortableView"
            value="comfortable"
          >
            <FontAwesomeIcon fixedWidth icon={faThList} />
          </UiKitRadioButtonGroup.RadioButton>
          <UiKitRadioButtonGroup.RadioButton name="compactView" value="compact">
            <FontAwesomeIcon fixedWidth size="sm" icon={faList} />
          </UiKitRadioButtonGroup.RadioButton>
        </UiKitRadioButtonGroup>
        <div className="flex ml-4">
          <UiKitRadioButtonGroup
            selected={sort}
            onChange={event => {
              changeSort(event);
            }}
          >
            <UiKitRadioButtonGroup.RadioButton name="ascSort" value="asc">
              <FontAwesomeIcon fixedWidth icon={faSortAlphaUp} size="lg" />
            </UiKitRadioButtonGroup.RadioButton>
            <UiKitRadioButtonGroup.RadioButton name="descSort" value="desc">
              <FontAwesomeIcon fixedWidth icon={faSortAlphaDownAlt} size="lg" />
            </UiKitRadioButtonGroup.RadioButton>
          </UiKitRadioButtonGroup>
        </div>
      </div>
    </div>
  );
};

ToolbarComponents.propTypes = {
  view: PropTypes.string.isRequired,
  changeView: PropTypes.func,
  sort: PropTypes.string.isRequired,
  changeSort: PropTypes.func
};

export default ToolbarComponents;
